<template>
  <div class="root">
    <div class="frozen">
      <div class="cell frozen-cell">
        <GridChartEditor />
      </div>
    </div>

    <div class="columns-scroll">
      <div class="columns">
        <AppColumn>
          <AppCell :label="'chart parameters'">
            <GridEditorParameterManager />
          </AppCell>
          <AppCell :label="'event lines'">
            <GridEditorEventLineManager />
          </AppCell>
          <AppCell :label="'column parameters'">
            <GridEditorColumnManager />
          </AppCell>
          <AppCell :label="'note parameters'">
            <GridEditorNoteManager />
          </AppCell>
        </AppColumn>
        <AppColumn>
          <AppCell :label="'audio player'">
            <GridAudioPlayer />
          </AppCell>
          <AppCell :label="'audio analyser'">
            <GridAudioAnalyzer />
          </AppCell>
          <AppCell :label="'chart render'">
            <GridChartRenderManager />
          </AppCell>
        </AppColumn>
        <!-- <AppColumn>
          <SubEditor />
        </AppColumn> -->
        <AppColumn>
          <AppCell :label="'audio file manager'">
            <GridAudioFileManager />
          </AppCell>
          <AppCell :label="'chart file manager'">
            <GridChartFileManager />
          </AppCell>
          <AppCell :label="'editor preset manager'">
            <GridChartPresetManager />
          </AppCell>
        </AppColumn>
        <AppColumn>
          <AppCell :label="'logs'">
            <GridLogViewer />
          </AppCell>
        </AppColumn>
      </div>
    </div>
    <ToastNotification></ToastNotification>
  </div>
  <a href="/help.html">help</a>
</template>

<script setup>
import GridAudioPlayer from '@/components/gridCell/GridAudioPlayer.vue';
import GridChartEditor from '@/components/gridCell/GridChartEditor.vue';
import GridChartRenderManager from '@/components/gridCell/GridChartRenderManager.vue';
import GridAudioFileManager from '@/components/gridCell/GridAudioFileManager.vue';
import GridLogViewer from '@/components/gridCell/GridLogViewer.vue';
import GridAudioAnalyzer from '@/components/gridCell/GridAudioAnalyzer.vue';
import GridChartFileManager from '@/components/gridCell/GridChartFileManager.vue';
import ToastNotification from '@/components/gridStructure/ToastNotification.vue';
import AppCell from '@/components/gridStructure/AppCell.vue';
import AppColumn from '@/components/gridStructure/AppColumn.vue';
import GridEditorParameterManager from '@/components/gridCell/GridEditorParameterManager.vue';
import GridChartPresetManager from '@/components/gridCell/GridChartPresetManager.vue';
import GridEditorColumnManager from '@/components/gridCell/GridEditorColumnManager.vue';
import GridEditorNoteManager from '@/components/gridCell/GridEditorNoteManager.vue';
import { useChartRender } from '@/composables/chartRenderComposable.js';
import { useAudioStore } from '@/stores/AudioStore.js';
import { useChart } from '@/composables/chartComposable.js';
import { provide, watch } from 'vue';
import GridEditorEventLineManager from '@/components/gridCell/GridEditorEventLineManager.vue';


const audioStore = useAudioStore()
const mainChart = useChart()
const mainChartRender = useChartRender(mainChart)
provide('mainChart', mainChart)
provide('mainChartRender', mainChartRender)

</script>

<style>
body {
  margin: 0px;
}

.root {
  display: flex;
  height: 100%
}

.frozen {
  background: #f5f5f5;
  border-right: 1px solid #ccc;
}

.columns-scroll {
  flex: 1;
  height: 100%;
  overflow-x: scroll;
}

.columns {
  display: flex;
}

.frozen-cell {
  background: #ffffff;
}
</style>